import React, { useCallback } from 'react';

import { IGetRatingListResponseData } from '../../../services/getRealtorRatingList';
import { ERealtorRatingTableColumns } from '../../../constants';
import { ESortOrder } from '../../../types/sortOrder';
import { UserCardForAuthorObject } from '../../UserCard';
import { numberWithDelimiter, sortRealtorRatingItems } from '../../../utils';
import { Label } from './components/Label';
import * as s from './RealtorRatingTableTbody.css';

interface IRealtorRatingTableTbody {
  items: IGetRatingListResponseData[];
  sortOrdering: ERealtorRatingTableColumns;
  sortOrderingType: ESortOrder;
  agentId?: number;
}

/**
 * Тело таблицы рейтинга риелторов
 */
export const RealtorRatingTableTbody = ({
  items,
  sortOrdering,
  sortOrderingType,
  agentId,
}: IRealtorRatingTableTbody) => {
  const handleTrClick = useCallback((url: string) => {
    window.open(url, '_blank');
  }, []);

  return (
    <tbody>
      {sortRealtorRatingItems({ items, sortOrdering, sortOrderingType }).map(
        ({
          id,
          attributes: {
            position,
            rating,
            advicesCount,
            bestAdvicesCount,
            blogsCount,
            popularBlogsCount,
            reviewsCount,
            popularReviewsCount,
            specialist,
          },
        }) => (
          <tr
            key={id}
            className={`${s['tr']} ${specialist?.specialistLink ? s['_clickable'] : ''} ${
              agentId && specialist?.userId === agentId ? s['tr-agent'] : ''
            }`}
            onClick={specialist?.specialistLink ? () => handleTrClick(specialist.specialistLink as string) : undefined}
          >
            <td className={s['td-position']}>{position}</td>
            <td className={s['td-user-card']}>
              <UserCardForAuthorObject {...specialist} companyName={undefined} specialistLink={undefined} />
            </td>
            <td className={s['td-rating-label']}>
              <Label>{numberWithDelimiter(rating)}</Label>
            </td>
            <td className={s['td']}>{numberWithDelimiter(advicesCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(bestAdvicesCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(blogsCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(popularBlogsCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(reviewsCount)}</td>
            <td className={s['td']}>{numberWithDelimiter(popularReviewsCount)}</td>
          </tr>
        ),
      )}
    </tbody>
  );
};
